import { atom } from "recoil";
import moment from "moment";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimeActualMonthState = atom({
  key: "myTimeActualMonthState",
  default: moment().format("MM"),
  effects_UNSTABLE: [ocPersistAtom],
});
